import ApiUtil from '@/api/api.util'
import ApiConfig from '@/api/api.config'

const encStoreModule = {
    state: {
        enc: {}
    },
    getters: {},
    mutations: {
        setPublicKeyData(state, data) {
            state.enc.data = data
        },
    },
    actions: {

        /**********************************************************************
         * [주의사항]
         * actions 안에 정의하는 함수는 모듈별로 네임스페이스를 구분하지 않으므로,
         * 다른 모듈에서 사용하는 이름을 중복으로 사용하지 않아야 합니다.
         *
         * vue 모듈 안의 함수에서는 다음과 같이 호출이 가능합니다.
         *
         * this.$store.dispatch('initSearchData')
         *********************************************************************/

        /**
         * 페이지 로딩시 최초로 검색창 세팅.
         * 데이터를 ajax로 가져와서 세팅해야합니다.
         */
        initPublicKey (context) {
            /** 권한 리스트 */
            const url = `${ApiConfig.eklDomain}/v1/ebmp/common/util/encDec/keyIssuance`
            ApiUtil.get(url).then(response => {
                if (!response || !response.data || response.data.resultData === undefined) {
                    return
                }
                const resultData = response.data.resultData
                context.commit('setPublicKeyData', resultData)
            })
        },
    }
}

export default encStoreModule
